import cx from 'classnames';
/**
 * 创建一个带前缀的 classnames， 返回一个功能和 classnames 完全一致但是每个类名会带一个前缀的 classnames, 可以通过在类名前加 ! 取消前缀
 * @param prefixes
 * @example
 *
 * let cx = classNameBuilder('prefix1', 'prefix2')
 * cx('aa', 'bb') // => `prefix1-prefix2-aa prefix1-prefix2-bb`
 * cx('aa', '!bb') // => `prefix1-prefix2-aa bb`
 */
export function classNameBuilder() {
    var prefixes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        prefixes[_i] = arguments[_i];
    }
    var prefix = prefixes.join('-');
    return function () {
        var cls = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            cls[_i] = arguments[_i];
        }
        if (cls.length == 0) {
            return prefix || '';
        }
        return cx(cls).split(/\s+/g).map(function (c) {
            if (c[0] === '!') {
                return c.slice(1);
            }
            else {
                return prefix ? "".concat(prefix, "-").concat(c) : c;
            }
        }).join(' ');
    };
}
;
//# sourceMappingURL=class-name-builder.js.map